import { Button, Paper } from '@material-ui/core';
import { MainRoutePath } from 'library/Routes';
import React from 'react';
import { useHistory } from 'react-router-dom';

export default function Error404() {
  const history = useHistory();
  return (
    <Paper>
      Página não encontrada!
      <br />
      <br />
      <Button
        onClick={() => {
          const mainPath: string | string[] | undefined = MainRoutePath;
          if (typeof mainPath === 'string') {
            history.push(mainPath);
          }
        }}
      >
        Voltar para a Home
      </Button>
    </Paper>
  );
}
